// extracted by mini-css-extract-plugin
export default {"routineblock":"jS","container":"kS","carousel":"lS","routine":"mS","heading":"nS","routinelist":"oS","routineitem":"pS","routineimg":"qS","routinedesc":"rS","routinename":"sS","routinetext":"tS","carouselwrap":"uS"};
    if(module.hot) {
      // 1711394579440
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  